import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { CustomTranslationService } from '../translation/custom-translation.service';

@Injectable({
  providedIn: 'root'
})
/**
 * Generic service class to provide notification messages according to the needed scope.
 */
export class ToastrMsgService {

  constructor(private toastr: ToastrService, private translateSrv: CustomTranslationService) { }

  showSuccess(message?: string | undefined, title?: string | undefined, configs?: Partial<IndividualConfig> | undefined) {
    
    this.toastr.success(this.getTranslation(message), this.getTranslation(title), configs);
  }

  showError(message?: string | undefined, title?: string | undefined, configs?: Partial<IndividualConfig> | undefined) {
    this.toastr.error(this.getTranslation(message), this.getTranslation(title), configs);
  }

  showWarning(message?: string | undefined, title?: string | undefined, configs?: Partial<IndividualConfig> | undefined) {
    this.toastr.warning(this.getTranslation(message), this.getTranslation(title), configs);
  }

  showInfo(message?: string | undefined, title?: string | undefined, configs?: Partial<IndividualConfig> | undefined) {
    this.toastr.info(this.getTranslation(message), this.getTranslation(title), configs);
  }

  private getTranslation(key?: string): string {
    if (key) {
      return this.translateSrv.instant(key);
    }
    return '';
  }
}
